import request from '@/utils/request'

// ==================== 会员等级管理接口 ====================

// 创建会员等级
export function createMembershipLevel(data) {
  return request({
    url: '/admin/membership-levels',
    method: 'post',
    data
  })
}

// 查询会员等级列表
export function getMembershipLevelList(params) {
  return request({
    url: '/admin/membership-levels',
    method: 'get',
    params
  })
}

// 获取会员等级详情
export function getMembershipLevelDetail(levelId) {
  return request({
    url: `/admin/membership-levels/${levelId}`,
    method: 'get'
  })
}

// 更新会员等级信息
export function updateMembershipLevel(levelId, data) {
  return request({
    url: `/admin/membership-levels/${levelId}`,
    method: 'put',
    data
  })
}

// 删除会员等级
export function deleteMembershipLevel(levelId) {
  return request({
    url: `/admin/membership-levels/${levelId}`,
    method: 'delete'
  })
}

// 批量更新会员等级排序
export function updateMembershipLevelSort(data) {
  return request({
    url: '/admin/membership-levels/sort',
    method: 'put',
    data
  })
}
